module.exports = __webpack_public_path__ + "static/media/jumbled-words-polar-bear.dcdee9f1.svg";